import { connect } from 'react-redux';
import WalletRegisterPage from 'src/components/views/Wallet/WalletRegisterPage';
import { IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isAgent, isDomestic, userInfo } }: IStoreState) => ({
  isAgent,
  isDomestic,
  userInfo,
});

export default connect(mapStateToProps)(WalletRegisterPage);


// WEBPACK FOOTER //
// ./src/containers/WalletRegister.ts